<template>
  <Teleport to="body">
  <div class="c-modal modal show in" tabindex="-1" role="dialog" :style="styleObject">
    <div ref="modalBackdrop"  class="c-modal-backdrop modal-backdrop show in" @click="$emit('close')" style="height: 100%;"></div>
    <div ref="modalDialog" class="c-modal-dialog" :class="`modal-dialog modal-${size}`" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="modal-title" :class="classTitle">
            <slot name="title">
              <h3 style="margin: 0;">{{ title }}</h3>
            </slot>
          </div>
        </div>
        <slot></slot>
      </div>
    </div>
  </div>
  </Teleport>
</template>


<script>
import Teleport from 'vue2-teleport';


export default {
  components: {
    Teleport,
  },
  mounted() {
    // Backdrop is fixed to the viewport (see styles), so it always covers the
    // full area regardless of how tall the dialog grows after async content loads.
    Array.from(document.querySelectorAll('.modal')).forEach(function(el){
      el.scrollTo(0,0)
    })

    document.body.style.overflow = 'hidden';
  },
  beforeDestroy() {
    document.body.style.overflow = 'auto';
  },
  props: {
    classTitle:{
      type: String,
      default: ''
    },
    styleObject:{
      type: Object,
      default: {},
    },
    title: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'lg'
    }
  },
  emits: ['close']
}
</script>

<style scoped>
.c-modal { overflow-x: hidden; }

.modal-title {
  font-weight: 600;
}

.modal-full {
  width: 100% !important;
  padding: 15px;

  box-sizing: border-box;
  max-width: 100%;
}

/* Центрування саме на мобілці: padding -> margin, 100% -> calc */
@media (max-width: 767px) {
  .modal-full {
    width: calc(100% - 30px) !important;
    padding: 0;                         /* щоб не було "псевдо-зсувів" */
    margin: 15px auto;
  }
}

/* Fixed to the viewport so it always covers the whole area — immune to the
   dialog growing taller after async content loads (no more disappearing overlay
   when scrolling a tall modal). Kept below the dialog so clicks reach content. */
.c-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}
/* Dialog sits above the backdrop within the modal's stacking context. */
.c-modal-dialog {
  position: relative;
  z-index: 1;
}
</style>
